import { CustomIconProps } from './art';

export const JobsIcon = (props: CustomIconProps): JSX.Element => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.385 7V3.667C17.385 2 15.846 2 15.846 2H8.231s-1.699.003-1.616 1.667V7H3.538S2 7 2 8.667v11.666C2 22 3.538 22 3.538 22h16.924S22 22 22 20.333V8.667C22 7 20.462 7 20.462 7h-3.077zM8.923 4.5h6.154V7H8.923V4.5z"
      fill={props.fill}
    />
  </svg>
);
